import React from 'react';
import {
  orderLineQty,
  type OpenOwnOrder,
  type PosOrderGroup,
} from '../../utils/pickListGrouping';

interface PickListOrderSelectProps {
  groups: PosOrderGroup[];
  selectedIds: Set<string>;
  onToggle: (orderId: string) => void;
  onToggleGroup: (orders: OpenOwnOrder[]) => void;
}

export const PickListOrderSelect: React.FC<PickListOrderSelectProps> = ({
  groups,
  selectedIds,
  onToggle,
  onToggleGroup,
}) => {
  if (groups.length === 0) {
    return (
      <p className="text-sm font-bold text-gray-500 text-center py-12">
        No open Own Delivery orders
      </p>
    );
  }

  return (
    <div className="space-y-3 pb-28">
      {groups.map((group) => {
        const allOn = group.orders.every((o) => selectedIds.has(o.id));
        return (
          <div
            key={group.key}
            className="bg-white rounded-2xl border-2 border-gray-100 p-3"
          >
            <label className="flex items-center gap-3 mb-2">
              <input
                type="checkbox"
                checked={allOn}
                onChange={() => onToggleGroup(group.orders)}
                className="h-5 w-5 accent-brand-600"
              />
              <span className="font-black text-gray-900">{group.posName}</span>
              <span className="text-xs text-gray-500">
                {group.posCity}
                {group.posCity ? ' · ' : ''}
                {group.lineCount} line{group.lineCount === 1 ? '' : 's'}
              </span>
            </label>
            <ul className="space-y-1 pl-8">
              {group.orders.map((order) => (
                <li key={order.id}>
                  <label className="flex items-center gap-2 text-sm">
                    <input
                      type="checkbox"
                      checked={selectedIds.has(order.id)}
                      onChange={() => onToggle(order.id)}
                      className="h-4 w-4 accent-brand-600"
                    />
                    <span className="font-bold text-gray-800">
                      {orderLineQty(order)} {order.product_name}
                    </span>
                    {order.variant_name ? (
                      <span className="text-gray-500">{order.variant_name}</span>
                    ) : null}
                  </label>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};
